module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Screens/learner/learner.component.css
// module id = ./src/app/Screens/learner/learner.component.css
// module chunks = main